import { useState, type ReactNode } from "react";
import {
  useFloating,
  offset,
  flip,
  shift,
  useClick,
  useDismiss,
  useRole,
  useInteractions,
} from "@floating-ui/react";

export type DropdownProps = {
  trigger: ReactNode;
  children: ReactNode;
};

export function Dropdown({ trigger, children }: DropdownProps) {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    middleware: [offset(6), flip(), shift({ padding: 8 })],
    placement: "bottom",
    strategy: "absolute",
    open: isOpen,
    onOpenChange: setIsOpen,
  });

  const click = useClick(context);

  const dismiss = useDismiss(context);

  const role = useRole(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    role,
    dismiss,
  ]);

  return (
    <>
      <div
        ref={refs.setReference}
        className="inline-block"
        {...getReferenceProps()}
      >
        {trigger}
      </div>

      {isOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          {...getFloatingProps()}
          className="z-50 min-w-[180px] max-w-sm rounded-md border border-brand-800 bg-brand-50 shadow-md overflow-hidden"
        >
          {children}
        </div>
      )}
    </>
  );
}

export default Dropdown;
